import { Object3D } from "three";


export class ClickMesh {
  protected _id:string;
  protected _name:string;
  protected _mesh:Object3D;

  constructor(node: Object3D) {
    this._mesh = node;
    this._id = node.uuid;
    this._name = node.parent?.name;
    this._mesh.visible = false;
  }

  protected update(raycast) {

  }

  public getMesh = ():Object3D => {
    return this._mesh;
  }

  public getMeshParent = ():Object3D => {
    return this.getMesh().parent;
  }

  get name(): string {
    return this._name;
  }

  get id(): string {
    return this._id;
  }

  show() {
    this.getMesh().visible = true;
  }
  hide() {
    this.getMesh().visible = false;
  }

}